import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

export default function ImageGallery({ item }) {
  const image = get(item, 'gallery_image');
  const title = get(item, 'title[0].text');

  if (!image || !image.url) {
    return false;
  }

  const srcSet = [];

  const smallUrl = get(image, '224x126.url');
  const smallWidth = get(image, '224x126.dimensions.width');
  const mediumUrl = get(image, '400x225.url');
  const mediumWidth = get(image, '400x225.dimensions.width');
  const largeUrl = get(image, '752x423.url');
  const largeWidth = get(image, '752x423.dimensions.width');

  const originalWidth = get(image, 'dimensions.width');

  if (originalWidth) {
    srcSet.push(`${image.url} ${originalWidth}w`);
  }

  if (largeUrl && largeWidth) {
    srcSet.push(`${largeUrl} ${largeWidth}w`);
  }
  if (mediumUrl && mediumWidth) {
    srcSet.push(`${mediumUrl} ${mediumWidth}w`);
  }
  if (smallUrl && smallWidth) {
    srcSet.push(`${smallUrl} ${smallWidth}w`);
  }

  return (
    <div className="responsive-image responsive-image--16by9 mb-4">
      <img
        srcSet={srcSet.join(', ')}
        sizes="(min-width: 1520px) 872px, (min-width: 1200px) 740px, (min-width: 992px) 621px, (min-width: 768px) 704px, (min-width: 576px) 492px, 95vw"
        src={image.url}
        alt={image.alt || title}
        className="img-fluid img-full img-force-full"
        loading="lazy"
      />
    </div>
  );
}

ImageGallery.propTypes = {
  item: PropTypes.shape({}).isRequired,
};
